<template>

  <div>
    <el-form :model="info" ref="info" :rules="rules" label-width="140px" class="global-form2">
      <el-form-item label="分区名称" prop="areaName">
        <el-input v-model="info.areaName" show-word-limit maxlength="20" placeholder="请输入区域名称"></el-input>
      </el-form-item>
      <el-form-item label="分区面积" prop="areaAcreage">
        <el-input v-model="info.areaAcreage" placeholder="请输入区域面积（㎡）" maxlength='9'></el-input>
      </el-form-item>
      <el-form-item label="区域负责人" prop="headUserId">
        <el-select v-model="info.headUserId" placeholder="请选择区域负责人" filterable clearable>
          <el-option v-for="item in projectUserList" :key="item.userId" :label="item.userName"
            :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分区范围" prop="locationList">
        <div class="map">
          <div class='rangeMapOperation'>
            <el-button-group>
              <el-button :class="[{ 'isActive': status === 'choose' }]" type="primary" @click="choosePolyon">
                <span class="iconfont icon-icon_map_tuodong"></span>
              </el-button>
              <el-button :class="[{ 'isActive': status === 'draw' }]" type="primary" @click="drawAreaPolyon">
                <span class="iconfont icon-icon_map_dianziweilan"></span>
              </el-button>
              <el-button v-if="status !== 'delete'" type="primary" @click="clearSelectPolygon">
                <img src="@/assets/icon/irrigation/icon_map_shanchu.svg">
              </el-button>
              <el-button v-else :class="[{ 'isActive': status === 'delete' }]" type="primary"
                @click="clearSelectPolygon">
                <img src="@/assets/icon/irrigation/icon_map_shanchu1.svg">
              </el-button>
            </el-button-group>
          </div>
          <div id="container"></div>
        </div>
      </el-form-item>

      <el-form-item prop="conserveLevel" label="设置区域保护等级">
        <el-select v-model="info.conserveLevel">
          <el-option value="A" label="A"></el-option>
          <el-option value="B" label="B"></el-option>
          <el-option value="C" label="C"></el-option>
          <el-option value="D" label="D"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="conserveElementIds" label="设置区域养护要素">
        <el-select v-model="info.conserveElementIds" multiple>
          <el-option v-for="(item, index) in elementList" :value="item.elementId" :label="item.elementName"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="conservePointIds" label="设置区域养护点位">
        <el-select v-model="info.conservePointIds" multiple>
          <el-option v-for="(item, index) in facilityList" :disabled="item.isBind === 1" :value="item.facilityId"
            :label="item.facilityName" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="conserveDesc" label="区域养护标准描述">
        <el-input type="textarea" maxlength="500" show-word-limit v-model="info.conserveDesc"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { drawPolygon } from '@/utils/formatData'
import { twoDecimal } from '@/utils/validate'
const polygonStyle = {
  strokeColor: '#3592FE',
  fillColor: '#3592FE',
  strokeWeight: 4,
  strokeOpacity: 1,
  fillOpacity: 0.3,
  strokeStyle: 'solid',
  zIndex: 100
}
const polygonSelectStyle = {
  strokeColor: '#FF402B',
  fillColor: '#FF402B',
  strokeWeight: 4,
  strokeOpacity: 1,
  fillOpacity: 0.5,
  strokeStyle: 'solid'
}
export default {
  name: 'List',
  components: {
  },
  data() {
    return {
      status: '',
      mouseTool: null,
      overlays: [],
      projectUserList: [],
      info: {
        areaName: '',
        areaAcreage: '',
        projectId: '',
        headUserId: '',
        locationList: [],
        conserveLevel: '', // 养护等级
        conserveDesc: '', // 养护标准描述
        conserveElementIds: [], // 养护要素IDS
        conservePointIds: [] // 养护点位IDS
      },
      elementList: [],
      facilityList: [],
      rules: {
        areaName: [{ required: true, message: '请输入分区名称', trigger: ['change'] }],
        locationList: [{ required: true, message: '请输入分区范围', trigger: ['change'] }],
        areaAcreage: [{ validator: twoDecimal, trigger: ['blur', 'change'] }]
      },
      map: null,
      submitShow: false,
      ploygons: [],
      selectPolygon: { ind: -1, polygon: null }
    }
  },
  computed: {
    areaId() {
      return this.$route.query.areaId
    },
    projectId() {
      return this.$route.query.projectId
    }
  },
  created() {
    this.info.projectId = this.projectId
    this.getProjectUserList()
    this.loadData().then(() => {
      if (this.areaId) {
        this.getDetail()
      }
    })
    this.loadElementList()
    this.loadFacilityList()
  },
  methods: {
    // 获取项目人员列表
    getProjectUserList() {
      this.$axios.get(this.$apis.project.selectYhProjectUserByList, {
        projectId: this.projectId
      }).then((res) => {
        this.projectUserList = res || []
      })
    },
    // 获取电子围栏
    loadData() {
      return new Promise((resolve, reject) => {
        this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
          projectId: this.projectId
        }).then((res) => {
          !this.map && this.loadMap({ latitude: res.latitude, longitude: res.longitude }, res.locationList)
          resolve(res)
        }).catch((res) => {
          reject(res)
        })
      })
    },
    // 巡查要素
    loadElementList() {
      this.$axios.get(this.$apis.patrol.selectElementByList).then(res => {
        this.elementList = res.list || []
      })
    },
    loadFacilityList() {
      this.$axios.get(this.$apis.project.selectProjectAreaYhPointList, {
        projectId: this.$route.query.projectId
      }).then(res => {
        this.facilityList = res || []
      })
    },
    // 区域详情
    getDetail() {
      this.$axios.get(this.$apis.project.selectYhProjectAreaByProjectAreaId, {
        projectAreaId: this.areaId
      }).then((res) => {
        res.conserveElementIds = res.conserveElementList.map((item) => item.obejctId)
        res.conservePointIds = res.conservePointList.map((item) => item.obejctId)
        this.info = res
        if (this.map) {
          this.overlays = drawPolygon(this.map, res.locationList, polygonStyle, null)
        }
      })
    },
    // 地图初始化
    loadMap(projectInfo, list) {
      AMap.plugin(['AMap.MouseTool'], () => {
        const center = [Number(projectInfo.longitude), Number(projectInfo.latitude)]
        const map = new AMap.Map('container', {
          center: center,
          zoom: 11
        })
        this.map = map
        drawPolygon(this.map, list, null, null)
        this.mouseTool = new AMap.MouseTool(this.map)
        this.mouseTool.on('draw', (e) => {
          // 面积计算，清除掉面积为0的非围栏所绘线条，四舍五入，面积小于0.5平方米的也舍弃
          const area = Math.round(AMap.GeometryUtil.ringArea(e.obj.getPath()))
          if (area > 0) {
            this.overlays.push(e.obj)
          } else {
            this.map.remove(e.obj)
            this.$message.warning('当前所画图形面积为0，无法保存。')
          }
        })
      })
    },
    // 选中
    choosePolyon() {
      this.status = 'choose'
      this.mouseTool.close()
      this.overlays.forEach(item => {
        item.on('click', this.polygonClick)
      })
    },
    // 绘制区域围栏
    drawAreaPolyon() {
      this.status = 'draw'
      this.overlays.forEach(item => {
        item.off('click', this.polygonClick)
      })
      this.mouseTool.polygon(polygonStyle)
    },
    polygonClick(e) {
      if (this.status === 'choose') {
        const ind = this.overlays.findIndex(item => item.contains(e.lnglat))
        if (ind >= 0) {
          this.selectPolygon.polygon && this.selectPolygon.polygon.setOptions(polygonStyle)
          this.selectPolygon.ind = ind
          this.selectPolygon.polygon = this.overlays[ind]
          this.selectPolygon.polygon.setOptions(polygonSelectStyle)
        }
      }
    },
    // 清除选中的围栏
    clearSelectPolygon() {
      this.status = 'delete'
      if (this.selectPolygon.ind >= 0) {
        this.$confirm('确定要删除选中的围栏？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.status = ''
          this.removePolygon()
        })
      } else {
        this.$message.warning('请先选中要删除的区域围栏！')
      }
    },
    // 从数组中清除选中的电子围栏
    removePolygon() {
      this.$message.success('删除围栏成功')
      this.map && this.map.remove(this.selectPolygon.polygon)
      this.overlays.splice(this.selectPolygon.ind, 1)
      this.selectPolygon = { ind: -1, polygon: null }
    },
    onSubmit() {
      const location = []
      this.overlays.forEach((item, index) => {
        const path = item.getPath()
        path.forEach((cItem) => {
          location.push({
            latitude: cItem.lat,
            longitude: cItem.lng,
            fenceCode: index
          })
        })
      })
      this.info.locationList = location
        ; (this.$refs.info).validate((valid) => {
          if (valid) {
            this.submitShow = true
            const url = this.areaId ? this.$apis.project.updateYhProjectArea : this.$apis.project.insertYhProjectArea
            this.$axios.post(url, {
              ...this.info
            }).then(() => {
              this.$message({ message: '保存成功', type: 'success' })
              this.$router.back()
            }).catch((err) => {
              this.submitShow = false
              this.$message(err)
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

#container {
  max-width: 100%;
  width: 600px;
  height: 500px;
  overflow: hidden;
  margin: 0;
}

.map {
  position: relative;

  .rangeMapOperation {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 999;

    .el-button-group {
      border: 1px solid $color-default;
      border-radius: 3px;

      .el-button {
        width: 64px;
        height: 46px;
        background-color: #fff;

        span {
          font-size: 28px;
          color: $color-default;
        }

        &.isActive {
          background-color: $color-default;

          span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
